"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
const Wrapper = (0, styled_components_1.default)('section') `
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 1rem;
`;
const C = ({ children, className }) => {
    if (!children) {
        return null;
    }
    return React.createElement(Wrapper, { className: className }, children);
};
exports.default = C;
